import React, { useEffect, useState } from "react"
import type { SetStateAction } from "react"
import type { DevEvent } from "./__core/eventsystem"
import { UnitTitleBlock } from "lib/components"
import { appTools, cn } from "lib/utils"
import { eventsystem, Viewers } from "./__core"
import { migrateFormats } from "../migration/migrateFormats"


const snippets = [
  { refstr: "migrate-formats", title: "Migrate Definition Formats", description: "Migrate definition formats from v2 to v3", clickFn: migrateFormats },
]

let idCounter = 0;

export default function CodeRunner(){
  const [events, setEvents] = useState<Array<DevEvent & { id: number }>>([]);

  useEffect(() => {
    const unsubscribe = eventsystem.subscribe((event: DevEvent) => {
      setEvents( (prev:any) => [...prev, { id: ++idCounter, ...event }]);
    });
  
    return () => {
      unsubscribe();
    };
  }, []);  

  return (
    <div className={cn("w-full pt-6 pb-36")}>
      <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="CodeRunner" />
      <div className="w-full flex justify-start items-start gap-5">
        <div className="w-3/12 flex flex-col gap-2">
          { snippets.map( (snippet:any) => (
            <div 
              key={snippet.refstr} 
              onClick={() => snippet.clickFn()}
              className={cn("w-full h-20 p-2 flex flex-col justify-center items-center border border-solid border-slate-700 cursor-pointer")}
            >
              <h5 className="text-base mb-1">{snippet.title}</h5>
              <p className="text-xs text-center">{snippet.description}</p> 
            </div>
          ))}
        </div>
        <div className="w-9/12 flex flex-col gap-2">  
          <div className="w-full h-[48rem] bg-neutral-900 overflow-y-auto font-geist_mono text-sm text-neutral-200 leading-relaxed">
            <Viewers.EventViewer  />
          </div>
        </div>
      </div>
    </div>
  )
}